import { Link } from "react-router-dom";
import { useScrollReveal } from "../../../hooks/useScrollReveal";

const steps = [
  {
    num: "01",
    title: "Bildmaterial-Analyse",
    desc: "Wir sichten Ihr vorhandenes Profi-Bildmaterial und definieren die gestalterische Vision für das Objekt.",
  },
  {
    num: "02",
    title: "Brand-Konzeption",
    desc: "Jedes Objekt erhält eine eigene Markenidentität: Name, Typografie, Farbwelt und Bildsprache.",
  },
  {
    num: "03",
    title: "Digitale Inszenierung",
    desc: "Wir entwickeln eine exklusive Landingpage mit eigenem Domain — ein digitales Erlebnis, das Kaufentscheidungen auslöst.",
  },
];

export default function B2BSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section className="pt-24 pb-16 px-8 lg:px-16 bg-warm-white">
      <div className="max-w-screen-xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left: Image with fixed gold frames */}
          <div
            className={`transition-all duration-800 ${
              isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
            }`}
          >
            <div className="relative p-6">
              <div className="absolute bottom-0 right-0 w-48 h-48 border border-gold/30 pointer-events-none" />
              <div className="absolute top-0 left-0 w-32 h-32 border border-gold/20 pointer-events-none" />
              <img
                src="https://public.readdy.ai/ai/img_res/03b7e6571f94cad62d91cc09540af51a.jpg"
                alt="Designer-Arbeitsplatz für digitales Immobilien-Branding in Zürich"
                className="relative z-10 w-full object-cover object-top"
                style={{ aspectRatio: "7/8" }}
              />
            </div>
          </div>

          {/* Right: Content */}
          <div
            ref={ref}
            className={`transition-all duration-800 delay-200 ${
              isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
            }`}
          >
            <p className="section-label mb-5">Unser Mehrwert</p>
            <h2 className="font-serif text-4xl lg:text-5xl text-text-primary leading-tight mb-5">
              Ihr Bildmaterial.
              <br />
              <em className="italic text-gold not-italic">Unsere Markenwelt.</em>
            </h2>
            <span className="gold-divider-left mb-6" />
            <p className="text-text-secondary font-sans font-light text-base leading-relaxed mb-4">
              Wir fotografieren nicht — wir veredeln. Das Profi-Bildmaterial, das Sie bereits besitzen, ist der Rohstoff. Wir erschaffen daraus eine maßgeschneiderte digitale Markenwelt, die Ihr Objekt in eine eigene Liga katapultiert.
            </p>
            <p className="text-text-secondary font-sans font-light text-base leading-relaxed mb-8">
              Das Ergebnis: Eine eigene Domain, ein eigenes Branding, eine eigene Geschichte — für jedes einzelne Objekt.
            </p>

            {/* Timeline Steps */}
            <div className="flex flex-col mb-8">
              {steps.map((step, index) => (
                <div key={step.num} className="flex gap-6 relative">
                  {index < steps.length - 1 && (
                    <div className="absolute left-[22px] top-[44px] w-px h-[calc(100%-12px)] bg-gold/15" />
                  )}
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-11 h-11 rounded-full border border-gold/40 flex items-center justify-center bg-warm-white">
                      <span className="font-serif text-sm text-gold font-semibold">{step.num}</span>
                    </div>
                  </div>
                  <div className={index < steps.length - 1 ? "pb-6" : ""}>
                    <h4 className="font-sans font-medium text-text-primary text-sm mb-1.5 mt-2.5">{step.title}</h4>
                    <p className="font-sans font-light text-text-secondary text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA below timeline */}
            <div className="pt-2 border-t border-light-gray mt-2">
              <Link
                to="/makler-service"
                className="inline-flex items-center gap-3 mt-6 text-xs tracking-luxury font-sans font-medium uppercase px-6 py-3 border border-gold/50 text-gold hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap group"
              >
                Mehr erfahren
                <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform duration-300" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
